/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveAccounts
 */
export interface ActiveAccounts {
    /**
     * The date for the end of the daily active accounts measurement window.
     * @type {Date}
     * @memberof ActiveAccounts
     */
    window_end: Date;
    /**
     * The number of active accounts for the 24hour window ending at window_end.
     * @type {number}
     * @memberof ActiveAccounts
     */
    active_accounts: number;
}

export function ActiveAccountsFromJSON(json: any): ActiveAccounts {
    return ActiveAccountsFromJSONTyped(json, false);
}

export function ActiveAccountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveAccounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'window_end': (new Date(json['window_end'])),
        'active_accounts': json['active_accounts'],
    };
}

export function ActiveAccountsToJSON(value?: ActiveAccounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'window_end': (value.window_end.toISOString()),
        'active_accounts': value.active_accounts,
    };
}


